import { alertMessagesArgsConfig, collectionFieldArgsConfig } from '../../utils/event_constants';

export const aiChatbotActions = [
  {
    name: 'answerFromChatbot',
    label: 'Answer From Chatbot',
    args: [
      {
        name: 'collectionForQuery',
        label: 'Select Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      collectionFieldArgsConfig({ name: 'fieldForQuery', label: 'Select Query Field' }),
      collectionFieldArgsConfig({ name: 'fieldForContext', label: 'Select Context Field' }),
      {
        name: 'collectionForAiChatbot',
        label: 'Select Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      collectionFieldArgsConfig({
        name: 'fieldForQueryContext',
        label: 'Select Query Context Field',
      }),
      collectionFieldArgsConfig({ name: 'fieldForAnswer', label: 'Select Answer Field' }),
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'continueConversation',
    label: 'Continue Conversation',
    args: [...alertMessagesArgsConfig],
  },
];
